const HTML_ESCAPES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

/**
 * Minimal HTML escape for API-supplied strings interpolated into the Gantt
 * tooltip, which renders with `useHTML: true` — an unescaped value is parsed as
 * markup. Covers text nodes and both quoting styles for attribute values.
 */
export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (char) => HTML_ESCAPES[char]);
}
